import {useToggle} from '@yandex-delivery/hooks'

import type {TariffsNddInfo} from '../../../../../../api'
import {Paper} from '../../../../../../components/ui'
import type {Resource} from '../../../../../../utils'
import {Map} from '../../../Map/Map'
import {FullScreenPolygonMap} from '../../components/FullScreenMap/FullScreenPolygonMap/FullScreenPolygonMap@desktop'
import {WorkInProgressScreen} from '../../components/WorkInProgressScreen/WorkInProgressScreen'
import styleClasses from './classes.module.css'

type InfoProps = {
  resource: Resource<TariffsNddInfo>
  tariff: string
  country: string
}

export function NddInfo({resource, ...screenProps}: InfoProps) {
  const {mapPolygon} = resource.read()

  const [modalOpened, toggleModalOpened] = useToggle(false)

  return mapPolygon ? (
    <Paper className={styleClasses.nddInfoMap}>
      <Map onFullSize={toggleModalOpened} polygon={mapPolygon} />

      <FullScreenPolygonMap onBack={toggleModalOpened} opened={modalOpened} polygon={mapPolygon} />
    </Paper>
  ) : (
    <WorkInProgressScreen {...screenProps} />
  )
}
